const DEFAULT_ALLOWED_EMAIL_DOMAINS = 'shahzadtex.com,shaheencotton.com';

export function allowedEmailDomains(): string[] {
  const raw =
    import.meta.env.VITE_ALLOWED_GOOGLE_DOMAINS || DEFAULT_ALLOWED_EMAIL_DOMAINS;
  return Array.from(
    new Set(
      raw
        .split(/[;,]/)
        .map((domain) => domain.trim().toLowerCase().replace(/^@/, ''))
        .filter(Boolean),
    ),
  );
}

export function isAllowedDashboardEmail(email: string): boolean {
  const normalized = email.trim().toLowerCase();
  return allowedEmailDomains().some((domain) => normalized.endsWith(`@${domain}`));
}

export function allowedEmailDomainsText(): string {
  return allowedEmailDomains()
    .map((domain) => `@${domain}`)
    .join(' or ');
}
